/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLocations200ResponseInner
 */
export interface GetLocations200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof GetLocations200ResponseInner
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof GetLocations200ResponseInner
     */
    longitude: number;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    regionCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    provinceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    neighborhood?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    addressDetails?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocations200ResponseInner
     */
    creationTime: string;
}

/**
 * Check if a given object implements the GetLocations200ResponseInner interface.
 */
export function instanceOfGetLocations200ResponseInner(value: object): value is GetLocations200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('regionCode' in value) || value['regionCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('creationTime' in value) || value['creationTime'] === undefined) return false;
    return true;
}

export function GetLocations200ResponseInnerFromJSON(json: any): GetLocations200ResponseInner {
    return GetLocations200ResponseInnerFromJSONTyped(json, false);
}

export function GetLocations200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocations200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'address': json['address'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'regionCode': json['regionCode'],
        'countryCode': json['countryCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'city': json['city'] == null ? undefined : json['city'],
        'province': json['province'] == null ? undefined : json['province'],
        'country': json['country'] == null ? undefined : json['country'],
        'addressDetails': json['addressDetails'] == null ? undefined : json['addressDetails'],
        'email': json['email'] == null ? undefined : json['email'],
        'organizationId': json['organizationId'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'creationTime': json['creationTime'],
    };
}

export function GetLocations200ResponseInnerToJSON(json: any): GetLocations200ResponseInner {
    return GetLocations200ResponseInnerToJSONTyped(json, false);
}

export function GetLocations200ResponseInnerToJSONTyped(value?: GetLocations200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': value['address'],
        'street': value['street'],
        'number': value['number'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'postalCode': value['postalCode'],
        'regionCode': value['regionCode'],
        'countryCode': value['countryCode'],
        'provinceCode': value['provinceCode'],
        'neighborhood': value['neighborhood'],
        'city': value['city'],
        'province': value['province'],
        'country': value['country'],
        'addressDetails': value['addressDetails'],
        'email': value['email'],
        'organizationId': value['organizationId'],
        'phoneNumber': value['phoneNumber'],
        'creationTime': value['creationTime'],
    };
}

